import { render, staticRenderFns } from "./TrainingModules.vue?vue&type=template&id=53f96115&scoped=true&"
import script from "./TrainingModules.vue?vue&type=script&lang=js&"
export * from "./TrainingModules.vue?vue&type=script&lang=js&"
import style0 from "./TrainingModules.vue?vue&type=style&index=0&id=53f96115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f96115",
  null
  
)

export default component.exports